/* Scentopia – блог: копиране на код/линк, съдържание на статията, лента за прогрес, споделяне. */
(function () {
  if (window.__scBlog) return;
  window.__scBlog = true;

  /* Копиране (промо код и линк към статията) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sc-copy]');
    if (!btn) return;
    e.preventDefault();
    var value = btn.getAttribute('data-sc-copy');
    var done = function () {
      btn.classList.add('is-copied');
      clearTimeout(btn._scT);
      btn._scT = setTimeout(function () { btn.classList.remove('is-copied'); }, 1800);
    };
    var fallback = function () {
      var t = document.createElement('textarea');
      t.value = value; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(t); done();
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(value).then(done, fallback);
    else fallback();
  });

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var art = document.querySelector('.sca');
    if (!art) return;
    var prose = art.querySelector('[data-sc-prose]');
    if (!prose) return;

    var norm = function (s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); };
    var title = norm(art.getAttribute('data-title'));

    /* 1. Заглавие, повторено в началото на текста – остава скрито; иначе го показваме */
    var first = prose.firstElementChild;
    var dup = null;
    if (first && first.tagName === 'H1') {
      var t = norm(first.textContent);
      if (t && (t === title || title.indexOf(t) === 0 || t.indexOf(title) === 0)) dup = first;
      else first.classList.add('sc-keep');
    }

    /* 2. Буквица на първия абзац */
    var el = prose.firstElementChild;
    while (el && (el === dup || !norm(el.textContent))) el = el.nextElementSibling;
    if (el && el.tagName === 'P' && el.textContent.trim().length > 140 && /^[A-Za-zА-Яа-яЁё]/.test(el.textContent.trim())) {
      el.classList.add('sc-drop');
    }

    /* 3. Таблиците се плъзгат хоризонтално на телефон */
    prose.querySelectorAll('table').forEach(function (tbl) {
      if (tbl.parentElement.classList.contains('sc-table')) return;
      var w = document.createElement('div'); w.className = 'sc-table';
      tbl.parentNode.insertBefore(w, tbl); w.appendChild(tbl);
    });

    /* 4. Съдържание от заглавията */
    var heads = Array.prototype.filter.call(prose.querySelectorAll('h1, h2, h3'), function (h) {
      return h !== dup && norm(h.textContent).length > 1;
    });
    var tocItems = [];
    if (heads.length) {
      var lvl = function (h) { return parseInt(h.tagName.charAt(1), 10); };
      var minL = Math.min.apply(null, heads.map(lvl));
      var top = heads.filter(function (h) { return lvl(h) === minL; });
      var withSub = top.length < 5 && heads.filter(function (h) { return lvl(h) <= minL + 1; }).length <= 16;
      tocItems = heads.filter(function (h) { return lvl(h) === minL || (withSub && lvl(h) === minL + 1); })
        .map(function (h) { return { el: h, sub: lvl(h) > minL }; });
      if (top.length < 2 && !withSub) tocItems = [];
    }

    var used = {};
    var slug = function (s) {
      var base = norm(s).replace(/[^\p{L}\p{N}]+/gu, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'razdel';
      var id = base, n = 2;
      while (used[id] || document.getElementById(id)) id = base + '-' + n++;
      used[id] = true;
      return id;
    };

    var links = [];
    if (tocItems.length >= 3) {
      var build = function (list, track) {
        var frag = document.createDocumentFragment();
        tocItems.forEach(function (it) {
          if (!it.el.id) it.el.id = slug(it.el.textContent);
          var li = document.createElement('li');
          if (it.sub) li.className = 'is-sub';
          var a = document.createElement('a');
          a.href = '#' + it.el.id;
          var txt = it.el.textContent.replace(/\s+/g, ' ').trim();
          a.textContent = txt.length > 80 ? txt.slice(0, 78) + '…' : txt;
          li.appendChild(a); frag.appendChild(li);
          if (track) links.push({ a: a, el: it.el });
        });
        list.appendChild(frag);
      };
      var desk = art.querySelector('[data-sc-toc]');
      var mobList = art.querySelector('[data-sc-toc-m-list]');
      if (desk) { build(desk, true); art.querySelector('[data-sc-toc-wrap]').hidden = false; }
      if (mobList) {
        build(mobList, !desk);
        var det = art.querySelector('[data-sc-toc-m]');
        det.hidden = false;
        mobList.addEventListener('click', function (e) { if (e.target.closest('a')) det.open = false; });
      }
    }

    /* 5. Лента за прогрес + активна точка в съдържанието */
    var bar = document.querySelector('[data-sc-progress]');
    var active = null;
    var update = function () {
      ticking = false;
      var r = prose.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      if (bar) {
        var p = (vh * 0.85 - r.top) / Math.max(r.height, 1);
        bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)).toFixed(4) + ')';
      }
      if (links.length) {
        var current = null;
        /* линията е малко под залепналото меню (scroll-margin-top на заглавията) */
        var line = (parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0) + (parseFloat(getComputedStyle(links[0].el).scrollMarginTop) || 0) + 40;
        for (var i = 0; i < links.length; i++) {
          if (links[i].el.getBoundingClientRect().top < line) current = links[i].el; else break;
        }
        if (current !== active) {
          active = current;
          links.forEach(function (l) { l.a.classList.toggle('is-active', l.el === current); });
        }
      }
    };
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      if (document.hidden) update(); else requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    /* 6. Системно споделяне на телефон */
    var share = art.querySelector('[data-sc-share]');
    if (share && navigator.share) {
      share.hidden = false;
      share.addEventListener('click', function () {
        navigator.share({ title: document.title, url: location.href.split('#')[0] }).catch(function () {});
      });
    }
  });
})();
